const AccountPageAccountDetailsStyles = ({ theme }: any) => {
  return {
    wrapper: {
      marginBottom: theme.spacing(1) * 3,
    },
    iconContainer: {
      width: 56,
    },
    iconSpacing: {
      paddingLeft: theme.spacing(1) * 7,
    },
    subheading: {
      marginBottom: theme.spacing(1) * 2,
    },
  };
};

export default AccountPageAccountDetailsStyles
